import { AppStateEnum } from '../../../main/types/app-state.types.ts';

export class IncorrectAttemptsUtil {
  private static _instance: IncorrectAttemptsUtil;

  public static get instance(): IncorrectAttemptsUtil {
    if (!IncorrectAttemptsUtil._instance) {
      IncorrectAttemptsUtil._instance = new IncorrectAttemptsUtil();
    }
    return IncorrectAttemptsUtil._instance;
  }

  handleStartStep(): void {
    // Nothing yet for Apollo Reading
  }

  // eslint-disable-next-line @typescript-eslint/require-await
  async handleIncorrectStep(): Promise<AppStateEnum> {
    // Implement task-based retry logic here
    return AppStateEnum.ReadyForNextStep;
  }
}

export const getIncorrectAttemptsUtil = (): IncorrectAttemptsUtil => IncorrectAttemptsUtil.instance;
